import {
  CollectionTileItemProps,
  HeroServiceItemProps,
  NavItemsProps,
  WhyChooseUsEstateItemProps,
} from "../types";
import HS1 from "../assets/vegetable.svg";
import HS3 from "../assets/potato-left.svg";
import HSBG1 from "../assets/Home Page Image (1).jpg";
import HSBG3 from "../assets/Home Page Image (2).jpg";
// import Collection1 from "../assets/collection1.png";
import Collection2 from "../assets/same.png";
import Collection3 from "../assets/alright.png";
import WCS1 from "../assets/wcs1.svg";
import GAL8 from "../assets/chysonbig.png"
import GAL4 from "../assets/sweet-potato-flour.png";
import PROFILE1 from "../assets/1.jpg";
import PROFILE2 from "../assets/2.jpg";
import PROFILE3 from "../assets/3.jpg";
import PROFILE4 from "../assets/4.jpg";
import GAL10 from "../assets/minna/OFSP_Bread_Process_5.jpg";
import GAL11 from "../assets/minna/OFSP_Bread_Process_9.jpg";


export const NavItems: NavItemsProps = {
  items: [
    {
      heading: "Home",
      url: "/",
      delay: 300,
      overview:
        "Start here to find the latest updates and highlights from our site.",
    },
    {
      heading: "About Us",
      url: "/about",
      delay: 350,
      overview: "Learn more about our company, our values, and our mission.",
    },
    {
      heading: "Our Work",
      url: "#",
      delay: 400,
      overview:
        "Explore our diverse range of products and services, including Trainings, Chyson Foods, and What We Do.",
      dropdownItem: [
     {
          value: "Farm Services",
          link: "/services/farming",
        },
        {
          value: "Gallery",
          link: "/services/gallery",
        },
       
        {
          value: "Chyson Foods",
          link: "/services/chyson-foods",
        },
        {
          value: "What We Do",
          link: "/services/what-we-do",
        },
      ],
    },
    {
      heading: "Training & Mentorship",
      url: "/services/training",
      delay: 350,
      overview: "Join us in our trainings.",
    },  
    {
      heading: "Contact",
      url: "/contact",
      delay: 500,
      overview: "Reach out to us with any questions, feedback, or inquiries.",
    },
  ],
};

export const HeroServiceItemData: HeroServiceItemProps = {
  items: [
    {
      bg: HSBG1,
      image: HS1,
      title: "Orange-Fleshed Sweet Potato (OFSP)",
      description:
        "Providing nutritious food crops that contribute to a healthier nation and improve national productivity by enhancing the health of Nigerians through better nutrition.",
      url: "/services/what-we-do",
    },
    {
      bg: HSBG3,
      image: HS3,
      title: "Purple-Fleshed Sweet Potato (PFSP)",
      description:
        "Leveraging cutting-edge agricultural technologies to enhance food security and ensuring lagship crops in driving agricultural and nutritional transformation.",
      url: "/services/what-we-do#chyson-foods",
    },
  ],
};
export const CollectionData: CollectionTileItemProps = {
  items: [
    {
      image: GAL8,
      title: "Sweet Potato Fresh Fries",
      description:
        "Naturally rich in beta-carotene, our fresh Orange-Fleshed Sweet Potato tubers are perfect for home cooking and commercial use.",
      star: "5",
      price: "1k",
    },
    {
      image: Collection2,
      title: "OFSP Sweet Potato Flour (Regular)",
      description:
        "Our OFSP flour is a versatile ingredient for baking and cooking, packed with nutrients and flavor.",
      star: "4.5",
      price: "900",
    },
    {
      image: Collection3,
      title: "Yellow Maize & OFSP Pap Powder",
      description:
        " A nutritious blend of yellow maize and OFSP, this pap powder is perfect for breakfast or snacks, packed with vitamins and minerals.",
      star: "4.1",
      price: "480",
    },
    {
      image: GAL4,
      title: "OFSP Sweet Potato Flour (Fermented)",
      description:
        "Our fermented OFSP flour is a unique ingredient for traditional dishes, offering a distinct flavor and nutritional benefits.",
      star: "5",
      price: "900",
    },
    {
      image: GAL8,
      title: "OFSP Sweet Potato Dried Chips",
      description:
        "Deliciously crunchy and naturally sweet, our dried chips are a wholesome snack for any time of the day.",
      star: "5",
      price: "1k",
    },
    {
      image: GAL10,
      title: "OFSP Sweet Potato Sliced Bread",
      description:
        "Our OFSP bread is a delicious and nutritious option for your daily meals, made with high-quality ingredients.",
      star: "5",
      price: "1k",
    },
    {
      image: GAL11,
      title: "OFSP Sweet Potato Un-Sliced Bread",
      description:
        "Our unsliced OFSP bread is perfect for sandwiches or toasting, offering a delightful taste and texture.",
      star: "5",
      price: "600",
    },
  ],
};

export const WhyChooseUsRealEstateData: WhyChooseUsEstateItemProps = {
  items: [
    {
      icon: WCS1,
      title: "Sustainability",
      description:
        "We are committed to environmentally friendly and climate-resilient agricultural practices.",
    },
    {
      icon: WCS1,
      title: "Innovation",
      description:
        "Simdozi leverages cutting-edge agricultural technologies to enhance food security.",
    },
    {
      icon: WCS1,
      title: "Quality",
      description:
        "We uphold the highest standards in food production and processing.",
    },
  ],
};
export const Testimonials = [
  {
    name: "Sakariyah Shakiru (aka Farmer Ebony)",
    role: "Smallholder Farmer, Epe, Lagos, Nigeria",
    testimony:
      "The OFSP training by Simdozi International in May 2024 was a game-changer. It taught me essential farming skills and helped me grow my business. Now I supply OFSP online, and my brand, “Orange Flesh Potato,” is thriving.",
    fullTestimony: `I am Sakariyah Shakiru, popularly known as Farmer Ebony, a smallholder farmer based in Epe, Lagos State.

I was fortunate to be among the participants of the first cohort of the Orange-Fleshed Sweet Potato (OFSP) Value Chain Development Training, organized and facilitated by Simdozi International Company, Abuja, in May 2024.

The training was a game-changer for me. It thoroughly focused on improved production techniques, good agricultural practices (GAP), nutritional benefits, and value addition within the OFSP value chain. Honestly, it was the first time I truly understood the depth and potential of orange-fleshed sweet potatoes.

I learned a wide range of practical skills—from proper land preparation, organic manure application, and effective weeding techniques to vine multiplication and consistent production strategies. I also gained valuable insights into processing OFSP-based meals and how this crop plays a critical role in combating vitamin A deficiency in both children and adults.

Following the training, I started with ¾ of a plot and, due to the encouraging results, expanded to 1 1⁄2 plots within just two months. The yield was fantastic! I began supplying homes through online orders both within and outside my community. My first few customers came through the recommendation of my mentor, Dr. Udeala Nduka, when my crop was ready for harvest.

One standout moment I cherish is when a customer, who somehow found me online, called me "Orange Flesh Potato"—and proudly, the name stuck! She's now my number one customer and has introduced me to many more. Because of the trust I've built through OFSP, customers now also buy other produce from my farm. This integrity and marketing mindset are lessons I took directly from the training.

I am sincerely grateful to the organizers and trainers for this life-changing opportunity. I strongly encourage other farmers—especially the youth and women—to embrace OFSP farming for its dual benefits: sustainable income and improved community nutrition.

Thank you.
Farmer Ebony.`,
    image: PROFILE1,
    initials: "SS",
  },
  {
    name: "Agnes Joy Kamugisha ",
    role: "Trainee from Kampala, Uganda",
    testimony:
      " I joined Simdozi International's Hybrid Empowerment Training in September 2024. The training provided valuable insights into planting, vine multiplication, and OFSP-based products. I'm now growing OFSP and look forward to further progress. Thank you, Simdozi International, for your support.",
    fullTestimony: `My name is Agnes Joy Kamugisha from Kampala, Uganda, East Africa.
I was one of the trainees on Hybrid Empowerment Training on Orange Fleshed Sweet Potatoes Value Chain Development."held by Mr. Udeala Esonu Nduka from September 4th to 28th 2024 on

My interest in OFSP was ignited by a Gluten Free Flour ( a healthier  alternative to wheat flour)I stumbled upon on the Uganda market, with  OFSP Flour as a main ingredient

My research on the OFSP in Uganda yielded no results, so I resorted to the Internet, and that is when I landed on Simdozi International  Limited.
I sent a message and immediately got a response. 
Mr. Udeala told me about the online training coming up, and I immediately signed up. I was a bit sceptical like many online advertisements, but his assurance and trust made me comfortable. He even agreed to sign me up and do the first training without making any payments. 

The training was packed with  knowledge, we learnt about how to plant the OFSP, vine multiplication, enterprise development,  export opportunities, nutritional benefits, how to bake baked goods with OFSP, to mention but a few. 

I am currently growing OFSP on my small piece of land and have so much planned ahead. 

The journey is exciting, and I am very grateful for walking the journey with Mr. Udeala step by step even after the training. 
I can't thank you enough, Simdozi International Limited.`,
    image: PROFILE3,
    initials: "AJ",
  },
  {
    name: "Mgbeoma KUYE",
    role: "CEO of Kadmos Enterprises Nig Ltd (Kadmos Farms)",
    testimony:
      "SIMDOZI's training taught me planting techniques and diverse uses of OFSP in food and nutraceuticals. I now use OFSP in my meals, including 40% OFSP bread. I highly recommend the OFSP value chain and SIMDOZI's hands-on training for success in agribusiness.",
    fullTestimony: `My name is Mgbeoma KUYE, CEO of Kadmos Enterprises Nig Ltd (Kadmos Farms), located in Ogun State but with registered address as Lagos state.

I entered the Sweet Potato value chain as a Processor. I add value to Orange -Fleshed Sweet Potato, to produce flour, which has several uses and benefits. I also farm it.

I narrowed my interest to Orange -Fleshed Sweet Potato(OFSP) because of the high nutritional value, in my quest to curb Malnutrition, especially in Children. The High level beta carotene which converts to Vitamin A, in the body, highest Fibre- content (among all potatoes), very vital for colon health and the non- gluten presence, were the attraction.

My strong desire to get  broader knowledge on the innovations with OFSP, it's benefits and uses, opened up a huge opportunity through the SIMDOZI company training on the OFSP Value chain.

To say the least, my discoveries were very exciting: from learning how to cut and plant the vines for best yields, to the numerous uses and applications of OFSP, in the Nutraceutical industry, as Food- in baking bread, confectioneries, as Fibre- rich swallows, soup thickener, Drinks, Yoghurts, composites for Paps, Beans pudding (Moi-Moi), as side serve in salads, to mention a few.

I have become a first beneficiary of the value in this Superfood, as this has become my main meal and I eat bread made from 40% OFSP; all these new habits are resultant from the training.

For any Agribusiness Enthusiast or Practitioner, with plans to venture or  scale, I will readily recommend OFSP Value chain, as a viable business but the training will be very critical, for a sustainable business venture.

SIMDOZI company, Trainings are broad, easy- to- understand and so hands-on, through the live- onsite and online video practicals, so participants can join from across the globe, thanks to technology.`,
    image: PROFILE2,
    initials: "MK",
  },
  {
    name: "Abatan Usman",
    role: "Founder, Abusol Farms Limited",
    testimony:
      "I now feel more confident and equipped to make meaningful contributions to food as i highly recommend this training to anyone passionate about agriculture and innovation...",
    fullTestimony: `Attending the Orange-Fleshed Sweet Potato (OFSP) Training at Simdozi International was a game-changer for me. The training was insightful and tailored to address real challenges in the agricultural value chain. 

I gained hands-on experience in OFSP cultivation, processing, and value addition, which has significantly improved my farming operations and opened up new income opportunities. The facilitator and speakers were knowledgeable and supportive, and the entire learning environment was truly inspiring. 

I now feel more confident and equipped to make meaningful contributions to food security and agribusiness development. I highly recommend this training to anyone passionate about agriculture and innovation!

— Abatan Usman
Founder, Abusol Farms Limited.`,
    image: PROFILE4,
    initials: "AU",
  },
  
];